import React, { useContext } from 'react';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';
import { useTrackingPerformanceFactory } from '../hooks/usePerformanceTrackingFactory';
import { useReportFactory } from '../hooks/useReportFactory';
const RemoteContext = getOrCreateGlobalContext('RemoteContext');
export const useRemote = () => useContext(RemoteContext);
export const RemoteProvider = _ref => {
  let {
    children,
    scope,
    moduleName,
    isRemoteAlreadyInitialized
  } = _ref;
  const {
    trackLoading,
    trackReady
  } = useTrackingPerformanceFactory(scope, moduleName, isRemoteAlreadyInitialized);
  const {
    report
  } = useReportFactory({
    scope
  });
  return /*#__PURE__*/React.createElement(RemoteContext.Provider, {
    value: {
      scope,
      moduleName,
      trackLoading,
      trackReady,
      report
    }
  }, children);
};

////////////// Deprecated

/**
 * @deprecated
 */
const RemotePerformanceTrackingContext = getOrCreateGlobalContext('RemotePerformanceTrackingContext');

/**
 * @deprecated - use useRemote() instead
 */
export const useRemotePerformanceTracking = () => {
  const {
    trackLoading: reportRemoteLoading,
    trackReady: reportRemoteReady
  } = useRemote();
  return {
    reportRemoteLoading,
    reportRemoteReady
  };
};
const RemotePerformanceTrackingProviderInitializer = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    reportRemoteLoading,
    reportRemoteReady
  } = useRemotePerformanceTracking();
  return /*#__PURE__*/React.createElement(RemotePerformanceTrackingContext.Provider, {
    value: {
      reportRemoteLoading,
      reportRemoteReady
    }
  }, children);
};

/**
 * @deprecated
 */
export const RemotePerformanceTrackingProvider = _ref3 => {
  let {
    children,
    scope,
    moduleName,
    isRemoteAlreadyInitialized
  } = _ref3;
  return /*#__PURE__*/React.createElement(RemoteProvider, {
    scope: scope,
    moduleName: moduleName,
    isRemoteAlreadyInitialized: isRemoteAlreadyInitialized
  }, /*#__PURE__*/React.createElement(RemotePerformanceTrackingProviderInitializer, null, children));
};

/**
 * @deprecated
 */
//# sourceMappingURL=RemoteProvider.js.map